import "core-js/modules/es.array.includes.js";
import { computed, h, isVNode, reactive, watch, defineComponent, createVNode as _createVNode } from 'vue';
const DynamicIcon = props => {
  const {
    icon,
    iconStyle,
    iconClass: className,
    iconAttrs
  } = props;
  if (!icon) return '';
  if (typeof icon === 'string') {
    return _createVNode("i", {
      "class": className,
      "style": iconStyle
    }, null);
  } else if (isVNode(icon)) {
    return () => h(icon, iconAttrs);
  } else if (typeof icon === 'object' && (typeof icon.setup === 'function' || typeof icon.render === 'function')) {
    return () => h(icon, iconAttrs);
  } else if (typeof icon === 'function') {
    return h(icon, iconAttrs);
  }
  return '';
};
export default defineComponent({
  name: 'XIcon',
  components: {
    DynamicIcon
  },
  props: {
    icon: {
      type: [String, Object, Function],
      default: ''
    },
    iconProps: {
      type: Object,
      default: () => ({})
    },
    // icon为vNode传入的属性
    size: {
      type: [Number, String],
      default: 22,
      validator: v => {
        return ['medium', 'small', 'large'].includes(`${v}`) || /^\d*(px|em|rem|%)?$/i.test(`${v}`);
      }
    },
    color: {
      type: [String, Number],
      default: ''
    },
    status: {
      type: String,
      default: '',
      validator: value => ['', 'primary', 'success', 'warning', 'error', 'info', 'danger'].includes(value)
    },
    roll: {
      type: Boolean,
      default: false
    } // 图标是否旋转动画
  },
  setup(props) {
    const iconAttrs = reactive({
      size: props.size,
      color: props.color,
      status: props.status,
      roll: props.roll
    });
    watch(() => props, val => {
      const {
        size,
        color,
        status,
        roll
      } = val || {};
      Object.assign(iconAttrs, {
        size,
        color,
        status,
        roll
      });
    }, {
      deep: true,
      immediate: true
    });
    const iconClassNames = computed(() => {
      let themeColor = '';
      switch (iconAttrs.status) {
        case 'primary':
          themeColor = 'theme--primary';
          break;
        case 'success':
          themeColor = 'theme--success';
          break;
        case 'warning':
          themeColor = 'theme--warning';
          break;
        case 'error':
          themeColor = 'theme--error';
          break;
        case 'info':
          themeColor = 'theme--info';
          break;
        case 'danger':
          themeColor = 'theme--danger';
          break;
      }
      let iconSize = '';
      switch (iconAttrs.size) {
        case 'medium':
          iconSize = 'size--medium';
          break;
        case 'small':
          iconSize = 'size--small';
          break;
        case 'mini':
          iconSize = 'size--mini';
          break;
      }
      const classNames = {
        'x-ui-icon': true
      };
      if (themeColor) classNames[themeColor] = true;
      if (iconSize) classNames[iconSize] = true;
      if (iconAttrs.roll) classNames.roll = true;
      if (typeof props.icon === 'string' && props.icon.startsWith('vxe-icon-')) {
        Object.assign(classNames, {
          'vxe-icon': true,
          [props.icon]: true
        });
      } else if (typeof props.icon === 'string' && props.icon.startsWith('fa-')) {
        Object.assign(classNames, {
          'fa-icon': true,
          [props.icon]: true
        });
      } else if (typeof props.icon === 'string') {
        classNames[props.icon] = true;
      }
      return classNames;
    });
    const iconStyle = computed(() => {
      const styles = {};
      if (props.color && props.color.startsWith('#')) {
        styles.color = props.color;
      }
      if (iconAttrs.size && !['medium', 'small', 'mini'].includes(iconAttrs.size)) {
        if (/^\d*$/i.test(iconAttrs.size)) {
          styles['font-size'] = `${iconAttrs.size}px`;
        } else {
          styles['font-size'] = `${iconAttrs.size}`;
        }
      }
      return styles;
    });
    return {
      iconStyle,
      iconAttrs,
      iconClassNames
    };
  }
});